export enum OwnershipType {
  Resident = "Resident",
  Landlord = "Landlord",
}
